import { Link } from 'react-router-dom'

import Button from '../components/form/Button'
import { useI18N } from '../../libraries/i18n/hook'

const NotFoundPage = () => {
  const { t } = useI18N()
  return (
    <div className='flex flex-col justify-center items-center gap-3'>
      <h1>404</h1>
      <p className='text-center sm:max-w-[470px] mb-4'>
        {t('error.404')}
      </p>
      <Button><Link to='/'>Inicio</Link></Button>
    </div>
  )
}

export default NotFoundPage
